export default "__VITE_ASSET__75f80f08__"